import React from "react";
import { REQUEST_STATUS_DICTIONARY } from "consts";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const AccessRequestStatusAutoSuggest = (props) => {
    const suggestStatus = (q) => {
        if (q) {
            q = q.toLocaleLowerCase();
        }

        return Promise.resolve(
            Object
                .keys(REQUEST_STATUS_DICTIONARY)
                .filter(key => (REQUEST_STATUS_DICTIONARY[key] || "")
                    .toLocaleLowerCase()
                    .includes(q)
                )
        );
    }

    return (
        <AutoSuggest
            label="Status"
            fetchOptions={suggestStatus}
            renderOption={(key) => ({label: `${REQUEST_STATUS_DICTIONARY[key]}`, value: key})}
            optionIdentifier={(value) => value}
            {...props}
        />
    );
}

export default AccessRequestStatusAutoSuggest;
